import { supabase } from '../lib/supabase';

function edgeInvokeErrorMessage(data: unknown, fnError: { message: string }): string {
  const fromBody =
    data && typeof data === 'object' && data !== null && 'error' in data
      ? String((data as { error: string }).error)
      : '';
  return fromBody || fnError.message || 'Request failed';
}

export async function launchRevenueCollectionCampaign(campaignId: string): Promise<void> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Not authenticated');
  const { data, error: fnError } = await supabase.functions.invoke('launch_campaign', {
    body: { campaign_id: campaignId },
  });
  if (fnError) {
    throw new Error(edgeInvokeErrorMessage(data, fnError));
  }
}

export type AddCampaignHotelAction =
  | 'already_in_campaign'
  | 'inserted'
  | 'reactivated'
  | 'skipped_no_contact'
  | 'sent'
  | 'blocked_completed'
  | 'error';

export interface AddCampaignHotelResult {
  hotel_id: number;
  action: AddCampaignHotelAction;
  status: string;
  email_sent?: boolean;
  error?: string;
}

export interface AddHotelsToLaunchedCampaignResponse {
  success: boolean;
  results: AddCampaignHotelResult[];
}

export async function addHotelsToLaunchedCampaign(
  campaignId: string,
  hotelIds: number[],
): Promise<AddHotelsToLaunchedCampaignResponse> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Not authenticated');
  const { data, error: fnError } = await supabase.functions.invoke('add_campaign_hotels', {
    body: { campaign_id: campaignId, hotel_ids: hotelIds },
  });
  if (fnError) {
    throw new Error(edgeInvokeErrorMessage(data, fnError));
  }
  if (!data || typeof data !== 'object' || !('results' in data)) {
    throw new Error('Invalid response from add_campaign_hotels');
  }
  return data as AddHotelsToLaunchedCampaignResponse;
}
